import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useMessage } from "@/api/hooks";
import { ReadingPane } from "./ReadingPane";

/**
 * A single message on its own route (/mail/message/:messageId), filling the
 * window.
 *
 * With the reading pane set to "bottom" the reader gets a short stacked strip,
 * which is fine for a glance and useless for a long message — and there was no
 * way out of it: no full-screen view and no way to open a message in its own
 * tab. Double-clicking a row in the list opens this route in a new tab, and
 * the URL is a normal link, so it can be bookmarked or shared with a
 * colleague on the same tenant.
 */
export function MessageFullView() {
    const { messageId } = useParams<{ messageId: string }>();
    const navigate = useNavigate();
    const detail = useMessage(messageId ?? null);

    return (
        <div className="flex h-full min-h-0 flex-1 flex-col">
            <div className="flex shrink-0 items-center gap-2 border-b px-4 py-2">
                <button
                    type="button"
                    onClick={() => navigate("/mail")}
                    className="flex items-center gap-1.5 rounded-md px-2 py-1 text-sm text-muted-foreground hover:bg-accent"
                >
                    <ArrowLeft className="h-4 w-4" aria-hidden />
                    Back to mail
                </button>
            </div>
            <div className="flex min-h-0 flex-1 flex-col">
                <ReadingPane
                    message={detail.data ?? null}
                    isLoading={detail.isPending && Boolean(messageId)}
                    isError={detail.isError}
                    errorMessage={detail.error?.message}
                    onSelectMessage={(id) => navigate(`/mail/message/${id}`)}
                />
            </div>
        </div>
    );
}
